import React from 'react';
import { Box, Skeleton } from '@mui/material';

const SkeletonLoader = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height:'100%',
        margin: '0 auto', 
      }}
    >
      {/* Simulate an image placeholder */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height='100%' 
        animation="wave"
        sx={{
          border:'0.5px solid grey',
          borderRadius: '10px',
          mb: 2, 
          bgcolor: '#181819',
          '&::after': {
            background:
              'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)', // Lighter wave animation
          },
        }}
      />

      {/* Simulate a title placeholder */}
      {/* <Skeleton
        variant="text"
        width="80%"
        height={40} // Adjust height for your title
        animation="wave"
        sx={{
          mb: 1.5, // Add margin-bottom
          bgcolor: 'grey.900', // Dark background for skeleton
          '&::after': {
            background:
              'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)', // Lighter wave animation
          },
        }}
      /> */}

    </Box>
  );
};

export default SkeletonLoader;